/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { useForm } from "react-hook-form";

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { FormDataPersonalDataForm } from 'utils/typeServices';

import { Typography, Box } from '@mui/material';

import Input from 'components/views/form/Input';
import { ButtonRectangle } from 'components/views/form/Button';

const PersonalDataForm = ({ pushProgressStep }: { pushProgressStep: () => void }) => {
    const [isJuridical, setIsJuridical] = useState(false);
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);
    const [lastUpdatePhone, setLastUpdatePhone] = useState('');
    const { register, setValue, handleSubmit, watch, formState: { errors } } = useForm<FormDataPersonalDataForm>();

    const { dataSearchPersonData, dataFormAddress, handleUpdateFormPersonal } = useContext(DataContext);

    const [identity, birthData, phone, email, chassisOrBoard] = watch(['identity', 'birthData', 'phone', 'email', 'chassisOrBoard']);

    const handleParseDate = (birthData: string) => {
        if (birthData) {
            const [dia, mes, ano] = birthData.split('/');

            return new Date(`${ano}-${mes}-${dia}`).toISOString();
        }

        return '';
    }

    const handleOnSubmit = ({ name, identity, birthData, email, phone, chassisOrBoard }: FormDataPersonalDataForm) => {
        if (dataSearchPersonData && dataSearchPersonData.PESSOA && dataFormAddress) {
            const auxPhone = phone.replace(/\D/g, '');
            const { CD_PESSOA, CD_AGENDAMENTO, Telefone, CD_TIPO_PESSOA } = dataSearchPersonData.PESSOA;

            handleUpdateFormPersonal({
                CD_PESSOA,
                CD_AGENDAMENTO,
                NM_PESSOA: name,
                NR_CNPJ_CPF: identity,
                DT_NASCIMENTO: handleParseDate(birthData),
                DS_EMAIL: email,
                Telefone: {
                    CD_PESSOA_TELEFONE: Telefone.CD_PESSOA_TELEFONE,
                    NR_DDD: auxPhone.slice(0, 2),
                    NR_TELEFONE: auxPhone.slice(2),
                    DT_ALTERACAO: auxPhone.slice(2) === Telefone.NR_TELEFONE ? Telefone.DT_ALTERACAO : new Date().toISOString()
                },
                Endereco: dataFormAddress,
                CD_TIPO_PESSOA,
                DS_PLATAFORMA: chassisOrBoard?.replace(/_/g, '')?.toUpperCase()
            });

            pushProgressStep();
        }
    };

    useEffect(() => {
        if (dataSearchPersonData && dataSearchPersonData.PESSOA) {
            setValue('name', dataSearchPersonData.PESSOA.NM_PESSOA);
            setValue('email', dataSearchPersonData.PESSOA.DS_EMAIL);
            setValue('phone', `${dataSearchPersonData.PESSOA.Telefone.NR_DDD.replace(/[^0-9]/g, '')}${dataSearchPersonData.PESSOA.Telefone.NR_TELEFONE.replace(/[^0-9]/g, '')}`);
            const datePhone = dataSearchPersonData.PESSOA.Telefone.DT_ALTERACAO.split('T')[0].split('-');
            setLastUpdatePhone(`${datePhone[2]}-${datePhone[1]}-${datePhone[0]}`);

            if (dataSearchPersonData.PESSOA.CD_TIPO_PESSOA === 1) {
                setIsJuridical(true);
            }
        }

    }, [dataSearchPersonData]);

    useEffect(() => {
        if (Regex.email.test(email) && Regex.phone.test(phone) && Regex.identity.test(identity) && (isJuridical ? Regex.chassisOrBoard.test(chassisOrBoard) : Regex.birthData.test(birthData))) {
            setIsBtnDisabled(false);
            return;
        }

        setIsBtnDisabled(true);

    }, [email, phone, identity, birthData, chassisOrBoard]);

    return (
        <Box component='form' sx={{ 'button': { width: '100%' } }} onSubmit={handleSubmit(handleOnSubmit)}>
            <Typography fontWeight={700} sx={{
                fontSize: { xs: '1.25rem', md: '1rem' },
                textAlign: { xs: 'left', md: 'center' },
                paddingBottom: { xs: '1rem', md: '.5rem' }
            }}>
                Dados pessoais
            </Typography>
            <Box sx={{
                borderRadius: '10px',
                padding: { md: '1.38rem 1.2rem .3rem' },
                border: {
                    xs: 'none',
                    md: '1.5px solid rgba(12, 28, 51, 0.5)'
                }
            }}>
                <Input
                    name="name"
                    label={isJuridical ? "Nome completo / Razão social" : "Nome completo"}
                    placeholder="Nome"
                    type="text"
                    disabled
                    register={{ ...register("name") }}
                />

                <Input
                    name='email'
                    label='E-mail cadastrado'
                    placeholder='seuemail@email.com'
                    type='text'
                    error={!!errors.email}
                    textError="Insira o e-mail corretamente"
                    register={{ ...register("email", { pattern: Regex.email }) }}
                />

                <Box sx={{ width: { xs: 'calc(50% - .94rem)', md: '11.96rem' } }}>
                    <Input
                        name='phone'
                        label='Celular'
                        placeholder='(99) 99999-9999'
                        maskHolder='(99) 99999-9999'
                        type='tel'
                        mask
                        error={!!errors.phone}
                        textError="Insira um número de celular"
                        register={{ ...register("phone", { pattern: Regex.phone }) }}
                    />
                    {lastUpdatePhone &&
                        <Typography fontSize='.75rem' textAlign='left' sx={{
                            marginTop: { xs: '-1.2rem', md: '-.5rem' }
                        }}>
                            Atualizado: {lastUpdatePhone}
                        </Typography>
                    }
                </Box>
            </Box>

            <Typography sx={{
                fontSize: { xs: '.9375', md: '1rem' },
                textAlign: { xs: 'left', md: 'center' },
                padding: { xs: '1rem 0 1.25rem', md: '1.7rem 0 1.25rem' }
            }}>
                Para gerar o token, <b>preencha</b> os dados abaixo:
            </Typography>

            <Box display='grid' gridTemplateColumns='1fr 1fr' sx={{
                columnGap: { xs: '1.31rem', md: '.88rem' },
                paddingX: { md: '1.2rem' }
            }}>
                <Input
                    name='identity'
                    label='Insira seu CPF ou CNPJ'
                    placeholder='000.000.000-00'
                    type='tel'
                    mask
                    identity
                    textError="Insira um número válido"
                    register={{ ...register("identity", { pattern: Regex.identity }) }} />

                {isJuridical ?
                    <Input
                        name='chassisOrBoard'
                        label='Placa/Chassi'
                        placeholder='*aa9*99'
                        type='text'
                        mask
                        identity
                        typeIdentity='plaque'
                        register={{ ...register("chassisOrBoard", { pattern: Regex.chassisOrBoard }) }}
                        uppercase
                    />
                    :
                    <Input
                        name='birthData'
                        label='Data de nascimento *'
                        placeholder='10/01/1990'
                        maskHolder='99/99/9999'
                        type='phone'
                        mask
                        register={{ ...register("birthData") }} />
                }
            </Box>

            <ButtonRectangle name='GERAR TOKEN' type='submit' disabled={isBtnDisabled} />
        </Box>
    );
}

export default PersonalDataForm;